import { AxiosError } from 'axios';
import { apiUrl1, authHTTPClient } from './auth-client';
import { ICustomerBase, ISession, SESSION_HEADERS } from './session';

export interface IFrejaEIDAuthData {
  AuthRef: string;
  QrCode: string;
}

export interface IFrejaEIDAuthResult {
  Status: FrejaEIDStatus;
  Customers: ICustomerBase[];
}

export interface IFrejaEIdUserInfo {
  PersonId: string;
  EndOfLife: string;
  IsOrganisation: boolean;
  CustomerId: number;
}

export enum FrejaEIDStatus {
  Started = 'STARTED',
  DeliveredToMobile = 'DELIVERED_TO_MOBILE',
  Canceled = 'CANCELED',
  RP_Canceled = 'RP_CANCELED',
  Expired = 'EXPIRED',
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export enum FrejaAuthType {
  Personal = 1,
  Organization
}

export async function initiateFrejaEIdAuth(authType: FrejaAuthType) {
  const { data } = await authHTTPClient.post<IFrejaEIDAuthData>(
    `${apiUrl1}/auth/freja?authType=${authType}`
  );
  return data;
}

export async function collectFrejaEIdAuthState(authRef: string) {
  const { data } = await authHTTPClient.get<IFrejaEIDAuthResult>(`${apiUrl1}/auth/freja/collect`, {
    params: { authRef }
  });
  return data;
}

export async function finishFrejaEIdAuth(payload: { authRef: string; customerId: number }) {
  try {
    const { data } = await authHTTPClient.post<ISession>(`${apiUrl1}/auth/freja/finish`, payload, {
      headers: SESSION_HEADERS
    });
    return data;
  } catch (error) {
    const e = error as AxiosError;
    if (e?.response?.status === 403) {
      throw e;
    }

    throw new Error(e?.response?.data.Message);
  }
}

export async function cancelFrejaEIdAuth(authRef: string) {
  await authHTTPClient.delete(`${apiUrl1}/auth/freja`, { params: { authRef } });
}
